export default {
  items: [
    {
      name: 'Strona główna',
      url: '/',
      icon: 'icon-home'
    },
    {
      title: true,
      name: 'Panel',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Dokumenty',
      url: '/documents',
      icon: 'icon-docs',
      children: [
        {
          name: 'Lista',
          url: '/documents/list',
          icon: 'icon-list'
        },
        {
          name: 'Import',
          url: '/documents/manage',
          icon: 'icon-cloud-upload'
        },
        {
          name: 'Konfiguracje',
          url: '/documents/configurations',
          icon: 'icon-settings'
        }
      ]
    },
    {
      name: 'Etykiety',
      url: '/labels',
      icon: 'icon-tag',
      children: [
        {
          name: 'Zarządzaj',
          url: '/labels/list',
          icon: 'icon-equalizer'
        },
        {
          name: 'Dodaj etykietę',
          url: '/labels/manage',
          icon: 'icon-plus'
        },
      ]
    }
  ]
}
